module.exports = __webpack_public_path__ + "static/img/broadcast-welfare.cd5385e.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/broadcast-welfare.png
// module id = tRp1
// module chunks = 86